import gql from 'graphql-tag';

export const SPOTS_IDS_BY_BUILDING_OR_LOT = gql`
  query spotsIdsByBuildingOrLotIds($input: SpotsByBuildingOrLotIdsInput) {
    spotsIdsByBuildingOrLotIds(input: $input)
  }
`;
